module.exports = __webpack_public_path__ + "static/img/2-msg.755014a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2-msg.png
// module id = Phpa
// module chunks = 1